import { Children, ReturnComponent } from '@/utils/reactTypes';
import { Box } from '@mui/material';
import { AlertProps } from '@mui/material/Alert';

import { AxleAlert } from './AxleAlert';

export const AxleCallout = ({
    type,
    children,
    ...rest
}: {
    type: 'warning' | 'error' | 'info' | 'success';
    children: Children;
} & AlertProps): ReturnComponent => {
    return (
        <Box
            sx={{
                marginTop: 1,
                marginBottom: 2,
            }}
        >
            <AxleAlert severity={type} {...rest}>
                {children}
            </AxleAlert>
        </Box>
    );
};
